import React, { useState, useEffect } from 'react'
import BookmarkContext from './BookmarkContext'
import { toast } from 'react-toastify';

const BookmarkState = (props) => {
    const [openModal, setOpenModal] = useState(false);
    const [siteName, setSiteName] = useState("");
    const [siteURL, setSiteURL] = useState("");
    const [siteLogo, setSiteLogo] = useState("");
    const [bookmarkData, setBookmarkData] = useState([]);
    const [toggleButton, setToggleButton] = useState(true);
    const [id, setId] = useState("");
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [toggleProfile, setToggleProfile] = useState("");
    const [userName, setUserName] = useState("");
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [otp, setOtp] = useState("");

    const handleModal = () => {
        setOpenModal(prevModal => !prevModal);
        setToggleButton(true);
        setSiteLogo("");
        setSiteName("");
        setSiteURL("");
        setId("");
    }

    // const APIKEY = "http://localhost:5000";
    const APIKEY = "https://bookmark-backend-n4d2.onrender.com";

    const saveSite = async () => {
        if (!siteName || !siteURL) {
            alert("Please fill out all fields.");
            return;
        }

        const url = siteURL.startsWith("http") ? siteURL : `https://${siteURL}`;

        const logo = siteLogo === "" ? "https://cdn-icons-png.freepik.com/256/1361/1361685.png?ga=GA1.1.699605609.1745255270&semt=ais_hybrid" : siteLogo.startsWith("http") ? siteLogo : `https://${siteLogo}`;

        const webname = siteName;

        // const userID = localStorage.getItem('token');

        try {
            const response = await fetch(`${APIKEY}/api/siteBookmark/createBookmark`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem("token")
                },
                body: JSON.stringify({ url, logo, webname })
            })

            const data = await response.json();

            if (response.ok) {
                toast.success(data.message);
                setSiteURL("");
                setSiteName("");
                setSiteLogo("");
                setOpenModal(false);
                fetchBookmark();
            }
            else {
                console.log("Failed to Save Bookmark");
                toast.error("Something went wrong!");
            }
        } catch (error) {
            console.log("Failed to Save Bookmark ", error);
            toast.error("Something went wrong!");
        }
    }

    const fetchBookmark = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${APIKEY}/api/siteBookmark/readBookmark`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem("token")
                }
            });

            const data = await response.json();

            if (response.ok) {
                setBookmarkData(data.bookmarks);
                setLoading(false);
            } else {
                // toast.error(data.message);
                setLoading(false);
            }

        } catch (error) {
            console.log("Failed to fetch Bookmark");
            toast.error("Something went wrong!");
        }
    }

    const handleUpdate = (_id, logo, webname, url) => {
        handleModal(true);
        // console.log(_id, logo, webname, url);
        setSiteLogo(logo);
        setSiteName(webname);
        setSiteURL(url);
        setId(_id);
        setToggleButton(false);
    }

    const updateSite = async () => {
        if (!siteName || !siteURL) {
            alert("Please fill out all fields.");
            return;
        }

        const url = siteURL.startsWith("http") ? siteURL : `https://${siteURL}`;
        const logo = siteLogo === "" ? "https://website-app-assets.netlify.app/assets/bookmark-icon-p1MUAQiW.png" : siteLogo.startsWith("http") ? siteLogo : `https://${siteLogo}`;
        const webname = siteName;

        try {
            const response = await fetch(`${APIKEY}/api/siteBookmark/updateBookmark/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem("token")
                },
                body: JSON.stringify({ url, logo, webname })
            })

            if (response.ok) {
                handleModal(false);
                toast.success(`${webname} Bookmark Updated!`);
                setId("");
                setSiteLogo("");
                setSiteName("");
                setSiteURL("");
                fetchBookmark();
            }
        } catch (error) {
            console.log("Error while updating a Bookmark", error);
            toast.error("Something went wrong!");
        }
    }

    const handleDelete = (_id, webname) => {
        const confirmDelete = window.confirm("Are you sure to Delete this Bookmark?");
        if (confirmDelete) {
            confirmedDelete(_id);
        }
        else {
            toast.info(`${webname} Bookmark Delete Cancel`);
        }
    }

    const confirmedDelete = async (_id) => {
        try {
            const response = await fetch(`${APIKEY}/api/siteBookmark/deleteBookmark/${_id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem("token")
                }
            })

            const data = await response.json();

            if (response.ok) {
                toast.success(`${data.bookmarks.webname} Bookmark Deleted`);
                setBookmarkData(bookmarkData.filter((bookmark) => bookmark._id !== _id));
                // fetchBookmark();
            }

        } catch (error) {
            console.log("Error while Deleting a Bookmark", error);
            toast.error("Something went wrong!");
        }
    }

    const filteredBookmarks = bookmarkData.filter((bookmark) =>
        bookmark.webname.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const ascending = () => {
        const storedData = [...bookmarkData].sort((a, b) => {
            return a.webname.localeCompare(b.webname);
        })
        setBookmarkData(storedData);
    };

    const descending = () => {
        const bookmark = [...bookmarkData].sort((a, b) => {
            return b.webname.localeCompare(a.webname);
        });
        setBookmarkData(bookmark);
    }

    const handleSortChange = (e) => {
        const value = e.target.value;
        setSortOrder(value);
        if (value === "1") {
            ascending();
        }
        else if (value === "2") {
            descending();
        }
        else {
            fetchBookmark();
        }
    }

    const handleClearComponent = () => {
        setUserName("");
        setEmail("");
        setPassword("");
        setOtp("");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
    }

    const handleProfileClose = () => {
        setToggleProfile(prev => !prev);
        setUserName("");
        setEmail("");
        setPassword("");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
    }

    const handleProfile = async () => {
        try {
            const response = await fetch(`${APIKEY}/api/siteBookmark/profile`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem("token")
                }
            })

            const data = await response.json();

            if (response.ok) {
                setUserName(data.userProfile[0].name);
                setEmail(data.userProfile[0].email);
                setToggleProfile(prev => !prev);
            }
            else {
                setUserName("");
                setEmail("");
                setPassword("");
                toast.error("Something went wrong to fetch Profile!");
            }
        } catch (error) {
            console.log("Failed to fetch Profile");
            toast.error("Something went wrong!");
        }
    }

    const handleChangePassword = async () => {
        try {
            const response = await fetch(`${APIKEY}/api/siteBookmark/changePassword`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem("token")
                },
                body: JSON.stringify({ currentPassword, newPassword })
            })

            const data = await response.json();

            if (response.ok) {
                toast.success(data.message);
                setCurrentPassword("");
                setNewPassword("");
                setConfirmPassword("");
            }
            else {
                toast.error(data.message);
                setCurrentPassword("");
                setNewPassword("");
                setConfirmPassword("");
            }
        } catch (error) {
            console.log("Something went Wrong");
            toast.error("Something went Wrong");
        }
    }

    const isLoggedin = localStorage.getItem("User");

    useEffect(() => {
        if (isLoggedin) {
            fetchBookmark();
        }

    }, [isLoggedin])

    return (
        <BookmarkContext.Provider value={{ handleModal, saveSite, siteLogo, setSiteLogo, siteName, setSiteName, siteURL, setSiteURL, openModal, toggleButton, updateSite, searchTerm, setSearchTerm, email, setEmail, password, setPassword, toast, loading, sortOrder, handleSortChange, bookmarkData, handleUpdate, handleDelete, APIKEY, fetchBookmark, setBookmarkData, filteredBookmarks, handleProfile, toggleProfile, setToggleProfile, handleProfileClose, userName, setUserName, currentPassword, setCurrentPassword, newPassword, setNewPassword, confirmPassword, setConfirmPassword, handleChangePassword, setLoading, otp, setOtp, handleClearComponent }}>
            {props.children}
        </BookmarkContext.Provider>
    )
}

export default BookmarkState
